module.exports = __webpack_public_path__ + "static/media/white_cross.e8f83150.svg";